import { render, staticRenderFns } from "./SkidataEventToggle.vue?vue&type=template&id=2e99abc6&scoped=true"
import script from "./SkidataEventToggle.vue?vue&type=script&lang=js"
export * from "./SkidataEventToggle.vue?vue&type=script&lang=js"
import style0 from "./SkidataEventToggle.vue?vue&type=style&index=0&id=2e99abc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99abc6",
  null
  
)

export default component.exports